import { render, staticRenderFns } from "./epRecycleMore.vue?vue&type=template&id=fff8cd26&scoped=true"
import script from "./epRecycleMore.vue?vue&type=script&lang=js"
export * from "./epRecycleMore.vue?vue&type=script&lang=js"
import style0 from "./epRecycleMore.vue?vue&type=style&index=0&id=fff8cd26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff8cd26",
  null
  
)

export default component.exports